<template>
    <div class="certificates q-col-gutter-lg">
        <div v-if="hasSearch" class="row">
            <q-input square
                     dense
                     outlined
                     v-model="input"
                     @input="search"
                     label="Введите название">
                <template v-slot:prepend>
                    <q-icon name="search"/>
                </template>
            </q-input>
        </div>
        <div class="row pt-4">
            <div :key="`certificate-${certificate.id}`"
                 v-for="certificate in items"
                 @click="open(certificate)"
                 class="col-md-3 certificate p-2">
                <span class="mr-2"></span>
                <div>
                    <div>{{ certificate.name }}</div>
                    <a class="mt-2"
                       @click="click(certificate)"
                       v-if="certificate.files && certificate.files.pdf"
                       target="_blank"
                       :href="certificate.files.pdf">Смотреть</a>
                </div>
            </div>
            <certificate-zoom :images="images"/>
        </div>
    </div>
</template>

<script>
import {mapMutations, mapState} from "vuex";

export default {
    name: "Certificates",
    props: {
        certificates: {
            type: Array
        },
        hasSearch: {
            type: Boolean,
            default: () => true
        }
    },
    data() {
        return {
            items: [],
            input: '',
            linkClicked: false,
        }
    },
    mounted() {
        this.items = this.$props.certificates;

        if (window.location.hash.includes('certificate')) {
            const certificateId = window.location.hash.split('-')[1],
                certificate = this.items.find(i => parseInt(i.id) === parseInt(certificateId));

            if (certificate.files.image) {
                this.showCertificateZoomModal(certificate.files.image);
            }
        }
    },
    watch: {
        modalCertificateZoom(val) {
            if (!val) {
                window.history.replaceState(null, null, window.location.href.replace(window.location.hash, ''));
            }
        }
    },
    methods: {
        ...mapMutations('product', ['showCertificateZoomModal']),
        open(certificate) {
            if (!this.linkClicked) {
                if (certificate.files.image) {
                    window.history.replaceState(null, null, window.location.href + '#certificate-' + certificate.id);
                    this.showCertificateZoomModal(certificate.files.image);
                } else if (certificate.files.pdf) {
                    window.open(certificate.files.pdf, '_blank');
                }
            }
            this.linkClicked = false;
        },
        click(certificate) {
            this.linkClicked = true;
            window.open(certificate.files.pdf, '_blank');
        },
        search(val) {
            if (val.length < 2) {
                this.items = this.$props.certificates;
            } else {
                this.items = this.$props.certificates.filter(i => i.name.toLowerCase().includes(val.toLowerCase()));
            }
        },
    },
    computed: {
        ...mapState('product', ['modalCertificateZoom']),
        images() {
            return this.items.filter(i => i.files.image).map(i => ({image: i.files.image}));
        },
    }
}
</script>
